<template>
  <div v-if="organization">
    <organization-billing-form :organization="organization"
                               :saving="saving"
                               @cancel="$emit('cancel')"
                               @save="updateOrganization"/>
  </div>
</template>
<script>
import OrganizationBillingForm from "../Billing/OrganizationBillingForm.vue";
import {OrganizationsApi} from "../../Api/OrganizationsApi.js";

export default{
  components: {OrganizationBillingForm},

  data() {
    return {
      saving: false,
      organization: null
    }
  },

  async mounted() {
    this.organization = await OrganizationsApi.getOrganization()
  },

  methods: {
    async updateOrganization(params) {
      this.saving = true;
      try {
        await OrganizationsApi.updateOrganization(params)
        this.$emit('saved')
      } catch (error) {
        this.showErrorToast(this.getErrorMessages(error.body, true))
      } finally {
        this.saving = false
      }
    },
  }
}
</script>